import React from "react";
import { Card, Table, Row, Col, Typography } from "antd";

const { Title } = Typography;

export default function SalesOrderPendingTab({
  soCategorywise = [],
  soCustomerwise = [],
  soExecutivewise = [],
}) {
  const cardStyle = {
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    backgroundColor: "#fff",
    marginBottom: 16,
  };

  const tableProps = {
    size: "small",
    pagination: { pageSize: 10 }, // Set default page size
    bordered: false,
    scroll: { x: 400, y: 500 },
  };

  const cardTitle = (text, color = "#333") => (
    <span style={{ fontSize: 16, fontWeight: 600, color }}>{text}</span>
  );

  // Table columns
  const categoryColumns = [
    { title: "Sub Group", dataIndex: "SubGroup_Category", key: "SubGroup_Category" },
    { title: "Pending Qty", dataIndex: "PendingQty", key: "PendingQty", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Pending Value", dataIndex: "PendingValue", key: "PendingValue", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  const customerColumns = [
    { title: "Customer Name", dataIndex: "CustomerName", key: "CustomerName" },
    { title: "Pending Qty", dataIndex: "PendingQty", key: "PendingQty", align: "right" },
    { title: "Pending Value", dataIndex: "PendingValue", key: "PendingValue", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  const executiveColumns = [
    { title: "Sales Executive", dataIndex: "SalesExecutiveName", key: "SalesExecutiveName" },
    { title: "Pending Qty", dataIndex: "PendingQty", key: "PendingQty", align: "right" },
    { title: "Pending Value", dataIndex: "PendingValue", key: "PendingValue", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  return (
    <div className="sales-trend-tab" style={{ padding: 16 }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card
            title={cardTitle("Category Wise Sales Order Pending", "#c62828")}
            style={cardStyle}
            bodyStyle={{ padding: 12 }}
          >
            <Table
              columns={categoryColumns}
              dataSource={soCategorywise}
              rowKey="SubGroup_Category"
              {...tableProps}
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                pageData.forEach(({ PendingQty, PendingValue }) => {
                  totalQty += Number(PendingQty) || 0;
                  totalValue += Number(PendingValue) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card
            title={cardTitle("Customer Wise Sales Order Pending", "#c62828")}
            style={cardStyle}
            bodyStyle={{ padding: 12 }}
          >
            <Table
              columns={customerColumns}
              dataSource={soCustomerwise}
              rowKey="CustomerName"
              {...tableProps}
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                pageData.forEach(({ PendingQty, PendingValue }) => {
                  totalQty += Number(PendingQty) || 0;
                  totalValue += Number(PendingValue) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card
            title={cardTitle("Executive Wise Sales Order Pending", "#c62828")}
            style={cardStyle}
            bodyStyle={{ padding: 12 }}
          >
            <Table
              columns={executiveColumns}
              dataSource={soExecutivewise}
              rowKey="SalesExecutiveName"
              {...tableProps}
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                pageData.forEach(({ PendingQty, PendingValue }) => {
                  totalQty += Number(PendingQty) || 0;
                  totalValue += Number(PendingValue) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
